module.exports = __webpack_public_path__ + "img/GALLERY-CIAZ-1.22a910c0.jpg";